import { render, staticRenderFns } from "./TimeslotFeedbacks.vue?vue&type=template&id=a6ea64d4"
import script from "./TimeslotFeedbacks.vue?vue&type=script&lang=js"
export * from "./TimeslotFeedbacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports